/*jshint multistr: true */

// global variable so it can be used in template files
window.checkInputLength = function ($input) {

    if ($input.val().length === 0) {
        $input.removeClass('is_filled');
    } else {
        $input.addClass('is_filled');
    }

};

$(function () {

    function autostartPasswordReveal() {

        var $btn = $('.js_passwordReveal');

        if (!$btn.length) { return; }

        $btn.on('click', function () {

            var $this = $(this),
                $input = $this.siblings('.js_passwordField');

            $this.toggleClass('is_active');

            if ($this.hasClass('is_active')) {

                $input.attr('type', 'text');

            } else {

                $input.attr('type', 'password');

            }

        });

    }

    autostartPasswordReveal();

});
